import { render, staticRenderFns } from "./ChildrenTest2.vue?vue&type=template&id=6e7de7a6&scoped=true&"
import script from "./ChildrenTest2.vue?vue&type=script&lang=js&"
export * from "./ChildrenTest2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7de7a6",
  null
  
)

export default component.exports